import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Chip,
  useTheme,
  Button,
} from "@mui/material";
import {
  Verified,
  EmojiEvents,
  Security,
  TrendingUp,
  Stars,
  ArrowBack,
} from "@mui/icons-material";

export default function StatsText() {
  const theme = useTheme();
  // Chip items data
  const chipItems = [
    {
      _id: 1,
      label: "مجوز رسمی",
      icon: Verified,
      iconColor: "#2196F3",
      hoverColor: "rgba(33, 150, 243, 0.1)",
      borderColor: "#2196F3",
    },
    {
      _id: 2,
      label: "پیشرو در صنعت",
      icon: EmojiEvents,
      iconColor: "#FF9800",
      hoverColor: "rgba(255, 152, 0, 0.1)",
      borderColor: "#FF9800",
    },
    {
      _id: 3,
      label: "امنیت تضمینی",
      icon: Security,
      iconColor: "#4CAF50",
      hoverColor: "rgba(76, 175, 80, 0.1)",
      borderColor: "#4CAF50",
    },
    {
      _id: 4,
      label: "رضایت ۹۸٪ کاربران",
      icon: TrendingUp,
      iconColor: "#E91E63",
      hoverColor: "rgba(233, 30, 99, 0.1)",
      borderColor: "#E91E63",
    },
    {
      _id: 5,
      label: "تیم حرفه‌ای",
      icon: Stars,
      iconColor: "#9C27B0",
      hoverColor: "rgba(156, 39, 176, 0.1)",
      borderColor: "#9C27B0",
    },
  ];

  const items = chipItems.map((item) => (
    <Chip
      key={item._id}
      icon={
        <item.icon
          sx={{
            fontSize: 18,
            color: `${item.iconColor} !important`,
            mr: ".5rem",
          }}
        />
      }
      label={item.label}
      variant="outlined"
      sx={{
        borderRadius: 2,
        py: 2,
        // px: 1,
        width: { xs: "100%", sm: "49%", lg: "24%" },
        color: "text.disabled",
        "&:hover": {
          bgcolor: item.hoverColor,
          borderColor: item.borderColor,
        },
      }}
    />
  ));
  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* Main introduction text section */}
        <Box
          sx={{
            textAlign: "center",
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%,  ${theme.palette.primary.main} 100%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            آدین‌زون؛ هویت دیجیتال دنیای ورزش{" "}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              maxWidth: "800px",
              mx: "auto",
              color: "text.secondary",
              lineHeight: 1.8,
              mb: 1,
              textAlign: "justify",
              fontSize: "1.1rem",
            }}
          >
            آدین‌زون از دل یک نیاز واقعی متولد شد؛ نیاز به ایجاد یک مرجع قابل
            اعتماد که باشگاه‌ها، مربیان و ورزشکاران بتوانند در فضایی حرفه‌ای خود
            را معرفی کنند و مردم نیز با اطمینان انتخاب کنند. ما باور داریم هر
            مربی و هر باشگاه، شایسته داشتن یک هویت دیجیتال حرفه‌ای است. به همین
            دلیل آدین‌زون بستری را فراهم کرده تا هر مجموعه ورزشی بتواند پروفایل
            اختصاصی خود را داشته باشد، خدمات، سوابق، تصاویر، راه‌های ارتباطی و
            اطلاعات کامل خود را در یک صفحه منظم و معتبر به نمایش بگذارد.
            آدین‌زون فقط یک وب‌سایت نیست؛ پل ارتباطی میان باشگاه‌ها، مربیان و
            مردم است. جایی که انتخاب یک مربی یا باشگاه، سریع‌تر، مطمئن‌تر و
            شفاف‌تر انجام می‌شود و جامعه ورزش به یکدیگر نزدیک‌تر از همیشه خواهد
            بود. هدف ما ساختن اکوسیستمی است که در آن اعتماد، دیده‌شدن و رشد،
            برای همه اعضای دنیای ورزش امکان‌پذیر باشد.
          </Typography>
          {/* <Button
            direction={"row"}
            sx={{
              transition: "all .3s",
              // px: ".5rem",
              color: "primary.light",
              ":hover": { color: "primary.main" },
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              px: "1rem",
            }}
          >
            بیشتر بدون <ArrowBack fontSize="16px" />
          </Button> */}
        </Box>

        {/* Trust indicators - chips section */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-around"
          alignItems="center"
          sx={{
            flexWrap: "wrap",
            rowGap: ".5rem",
            // gap: 2,
          }}
        >
          {items}
        </Stack>
      </Container>
    </Box>
  );
}
